var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00013 6.51615C8.08902 6.51615 8.17502 6.53281 8.25813 6.56615C8.34169 6.59948 8.41124 6.64392 8.4668 6.69948L11.5335 9.76615C11.6557 9.88837 11.7168 10.0439 11.7168 10.2328C11.7168 10.4217 11.6557 10.5773 11.5335 10.6995C11.4112 10.8217 11.2557 10.8828 11.0668 10.8828C10.8779 10.8828 10.7224 10.8217 10.6001 10.6995L8.00013 8.09948L5.40013 10.6995C5.27791 10.8217 5.12235 10.8828 4.93346 10.8828C4.74457 10.8828 4.58902 10.8217 4.4668 10.6995C4.34457 10.5773 4.28346 10.4217 4.28346 10.2328C4.28346 10.0439 4.34457 9.88837 4.4668 9.76615L7.53346 6.69948C7.60013 6.63281 7.67235 6.5857 7.75013 6.55815C7.82791 6.53015 7.91124 6.51615 8.00013 6.51615Z",
    fill: "#7477B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/arrow-up-icon.b8c94c65.svg";
export { ForwardRef as ReactComponent };